import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { ActionSheetController, NavController } from '@ionic/angular';
import { AuthService } from 'src/app/services/auth.service';
import swal from 'sweetalert'
import PouchDB from 'pouchdb';
import { SeedsService } from 'src/app/services/seeds.service';
@Component({
  selector: 'app-vista-semillas',
  templateUrl: './vista-semillas.component.html',
  styleUrls: ['./vista-semillas.component.scss'],
})
export class VistaSemillasComponent implements OnInit {
  public role
  public proveedor
  public puntos: any=[];
  public textSearch:string=''
  public cargando: number=1;
  public limit
  public filteredSeeds
  public limiter=30
  public limiterInt
  public seeds
  public chargeMessage='Cargando..'
  public  filteredPuntos: any[] = [];
  constructor(
    public navCtrl:NavController,
    public auth:AngularFireAuth, 
    public db:AngularFirestore,
    public seedsService:SeedsService,
    public actionSheetController: ActionSheetController,
    public authS:AuthService) {
    
   }

  ngOnInit() {
    this.auth.auth.onAuthStateChanged(f=>{
      this.authS.datosPefilSesion(f.uid).subscribe(k=>{
         this.role=parseInt(k.data()['role'])
         console.log(this.role)
         if(this.role==3){
          this.proveedor=k.data()['uid']
         }else{
          this.proveedor=k.data()['proveedor']

         }
         this.valLimiter()
         
         
       
      })

    })
  }


 /**
  * The function takes the value of the input field and assigns it to the variable textSearch
  * @param e - the event object
  */
 searchSeeds(event: any): void {
  const text = event.target.value;
  this.textSearch = text;

   
  
}


 /**
  * It gets the points from the database and stores them in an array.
  */
  valLimiter(){
    this.puntos=[]
  //   this.db.collection('seeds',ref=>ref.where('uid_proveedor','==',this.proveedor)).get().subscribe(l=>{
  //     this.limiterInt=l.docs.length
  //     if( l.docs.length<=0 && l.docs.length>=30){
  //       this.traerPuntos()
  //     }else{
  //       this.traerPuntosCompletos()
  //       this.cargando=0
  //     }
  // })
  this.seeds=new PouchDB('maxsellglobal_mobile')
  const docs=this.seeds.allDocs({
    include_docs:true
    
  }).then(i=>{
   
    for(let e of i.rows){
      if(e.doc.uid_proveedor == window.localStorage.getItem('uidUser')){
        this.puntos.push(e.doc)
      }else{
        this.cargando=1
        this.chargeMessage='No presenta Puntos'
      }
  
    }
    if(this.puntos.length>0){
      this.cargando=0
    }else{
      this.cargando=1
      this.chargeMessage='No presenta Puntos'
    }
    
  })

  console.log(this.puntos)
  }

  // traerPuntos(){
  //   this.cargando=1
  //   this.db.collection('seeds',ref=>ref.limit(this.limiter)).get().subscribe(l=>{
  //       l.forEach(f=>{
    
  //         if(f.data()['uid_proveedor']==this.proveedor){
  //           this.cargando=1
  //           this.puntos.push(f.data(),{'fid':f.id})
     
  //           if(this.puntos.length>0){
  //             this.cargando=0
     
  //           }
  //         }
           
  //       })
  //   })
  // }

 /**
  * It gets the first 30 points from the database.
  */
  // traerPuntosCompletos(){
  //   this.puntos=[]
  //   this.db.collection('seeds',ref=>ref.where('uid_proveedor','==',this.proveedor)).get().subscribe(l=>{
  //       l.forEach(f=>{
       
  //         this.puntos.push(f.data())
  //         console.log(this.puntos)
  //       })
  //   })
  // }


 /**
  * It changes the limit of the points that are shown on the map.
  */
  // limitChange(){
  //   if(this.limit=="30"){
  //     this.limiter=30
  //     this.traerPuntos()

  //   }else if(this.limit=="60"){
  //     this.limiter=60
  //     this.traerPuntos()

  //   }else if(this.limit=="100"){
  //     this.limiter=100
  //     this.traerPuntos()
  //   }else{
  //     this.traerPuntosCompletos()
  //   }
  // }

/**
 * A function that allows you to update the seed.
 * @param ids - It's the id of the document that I want to update.
 */
  actualizarSemilla(ids){
    var id={
      'id':ids
    }
    window.localStorage.removeItem('idPunto')
    this.db.collection('seeds',ref=>ref.where('nombreEstablecimiento','==',ids.nombreEstablecimiento)).get().subscribe(l=>{
      l.forEach(o=>{
      
        window.localStorage.setItem('idPunto',o.id)
        this.navCtrl.navigateForward(['/seed-update'],{
          queryParams: {
              'service': JSON.stringify(id),
              'clavePunto':JSON.stringify(o.id)
          }})
      })
    })
   
   
  }

  eliminarSemilla(i){
    console.log(i)
    swal({
      title: "Estas Seguro de Eliminar este Punto?",
      text: "",
      icon: "warning",
      buttons: ['Cancelar','Aceptar']
     })
    .then((willDelete) => {
      if (willDelete) {

        this.db.collection('seeds').doc(i).delete().then(l=>{
          swal('Punto eliminado')
          //this.limitChange()          
          
        }).then(()=>{
          this.seedsService.eliminarPuntoBaseLocal(i).then(()=>{
            this.valLimiter()
          })
        })
       
      } else {
        swal("Cancelado");
      }
    });
   
  }
  
  async presentActionSheet(i,s) {
    console.log(i)
    console.log(s)
    const actionSheet = await this.actionSheetController.create({
      header: 'Acciones',
      buttons: [
        {
          text: 'Actualizar',
          icon: 'create-outline',
          handler: () => {
            this.actualizarSemilla(i)
         
          },
        },
        {
          text: 'Eliminar',
          icon: 'trash-outline',
          role: 'destructive',
          handler: () => {
            this.eliminarSemilla(s)
       
          },
        },
        {
          text: 'Cancelar',
          icon: 'close',
          role: 'cancel',
          handler: () => {
      
          },
        },
      ],
    });

    await actionSheet.present();
  }
}
